export const NAVIGATION_MENUS = [
  {
    name: 'network',
    key: 'network',
    path: '/network',
  },
  {
    name: 'Impact',
    key: 'impact',
    path: '/impact',
  },
  {
    name: 'collaborators',
    key: 'collaborators',
    path: '/collaborators',
  },
  {
    name: 'Learning Registry',
    key: 'learning-registry',
    path: '/learning-registry',
    subMenu: [
      {
        name: 'Registry',
        path: '/registry',
        key: 'registry',
      },
      {
        name: 'Data Lake',
        key: 'tool-providers',
        path: '/tool-providers',
      },
      {
        name: 'Reports',
        key: 'data-lake-report',
        path: '/data-lake-report',
      }],
  },
  {
    name: ' Data Lake',
    key: 'data-lake',
    path: '/data-lake',
    subMenu: [
      {
        name: 'Registry',
        path: '/registry',
        key: 'registry',
      }, {
        name: 'Data Lake',
        key: 'tool-providers',
        path: '/tool-providers',
      }],
  },
  {
    name: 'learners',
    key: 'learners',
    path: '/learners',
  },
  {
    name: 'Showcase',
    key: 'showcase',
    path: '/showcase',
  },
  {
    name: 'MyGooru',
    key: 'mygooru-insights',
    path: '/mygooru-insights',
  },
  // {
  //   name: 'research',
  //   key: 'research',
  //   path: '/projects',
  //   subMenu: [{
  //     name: 'projects',
  //     path: '/projects',
  //   }, {
  //     name: 'data',
  //     path: '/data',
  //   }],
  // },
  // {
  //   name: 'console',
  //   key: 'console',
  //   path: '/console',
  // },
];

export const PARTNERS_TYPE = [
  {
    labelKey: 'schools',
    type: 'schools',
    pathname: 'schools',
    partition: 2,
    tagName: 'Countries',
    showTop3Partners: true,
  },
  {
    labelKey: 'researcher.partners',
    type: 'researchers',
    pathname: 'researchers',
    tagName: 'Areas of Research',
    partition: 1,
    showTop3Partners: true,
  },
  {
    labelKey: 'content.developers',
    type: 'content_developers',
    pathname: 'content-developers',
    partition: 2,
    tagName: 'Disciplines',
    showTop3Partners: true,
  },
  {
    labelKey: 'common.lab_schools',
    type: 'lab_schools',
    pathname: 'lab-schools',
    partition: 1,
    tagName: 'Disciplines',
    showTop3Partners: true,
  },
  {
    labelKey: 'funders',
    type: 'funders',
    tagName: 'Funding',
    pathname: 'funders',
    partition: 1,
    showTop3Partners: true,
  },
  // {
  //   labelKey: 'administrators',
  //   type: 'implementation_partners',
  //   pathname: 'administrators',
  //   tagName: 'Countries',
  //   partition: 2,
  //   showTop3Partners: true,
  // },
  {
    labelKey: 'integration.partners',
    type: 'integration_partners',
    pathname: 'integration',
    partition: 2,
    tagName: 'Users',
    showTop3Partners: true,
  },
];

export const CONTENT_TYPE = [
  {
    labelKey: 'content.assessment',
    type: 'assessment',
  },
  {
    labelKey: 'content.collection',
    type: 'collection',
  },
  {
    labelKey: 'content.resource',
    type: 'resource',
  },
  {
    labelKey: 'content.offline.activity',
    type: 'offline-activity',
  },
  {
    labelKey: 'content.course',
    type: 'course',
  },
  {
    labelKey: 'content.question',
    type: 'question',
  },
];

export const CURICULUM_SUBJECT_LIST = ['All', 'Math', 'Science', 'ELA', 'Teacher PD'];

export const CURICULUM_TOOL_PROVIDER = [
  {
    toolName: 'Lexia',
    students: 645,
    minOrDay: '30',
    partition: 1,
    logo: '/img/default-images/partner.png',
    colorCode: '#3782c1',
    textColor: '#cdd2d6',
    subject: '',
  },
  {
    toolName: 'Scale Curiculum',
    students: 769,
    minOrDay: '25',
    partition: 1,
    logo: '/img/default-images/partner.png',
    colorCode: '#c0485c',
    textColor: '#cdd2d6',
    subject: '',
  },
  {
    toolName: 'Think Central',
    students: 974,
    minOrDay: '24',
    partition: 1,
    logo: '/img/default-images/partner.png',
    colorCode: '#378cdf',
    textColor: '#cdd2d6',
    subject: '',
  },
  {
    toolName: 'Navigator',
    students: 48530,
    minOrDay: '25',
    partition: 2,
    logo: '/img/default-images/partner.png',
    colorCode: '#ffffff',
    textColor: '#378cdf',
    subject: 'Math',
  },
  {
    toolName: 'Eureka Math',
    students: 6587,
    minOrDay: '25',
    partition: 2,
    logo: '/img/default-images/partner.png',
    colorCode: '#ffffff',
    textColor: '#86c250',
    subject: 'Math',
  },
  {
    toolName: 'National Geographic',
    students: 17920,
    minOrDay: '21',
    partition: 3,
    logo: '/img/default-images/partner.png',
    colorCode: '#fbda00',
    textColor: '#000000',
    subject: 'science',
  },
  {
    toolName: 'School District Curiculum',
    students: 3784,
    minOrDay: '28',
    partition: 3,
    logo: '/img/default-images/partner.png',
    colorCode: '#c0485c',
    textColor: '#cdd2d6',
    subject: 'Teacher',
  },
  {
    toolName: 'Houghton Mufflin',
    students: 1836,
    minOrDay: '29',
    partition: 3,
    logo: '/img/default-images/partner.png',
    colorCode: '#f3b800',
    textColor: '#000000',
    subject: '',
  },
];

export const CONTENT_DISTRIBUTION = {
  color: ['#ffffff', '#c5e5d0', '#9ed5b2', '#77c493', '#51b374'],
};

export const PRODUCT_URL = 'https://gooru.org';

export const CATEGORY_DISTRIBUTION = {
  color: ['#3180c0', '#bad4ea', '#8db8dc', '#5f9cce', '#ffffff'],
};

export const DEFAULT_IMAGES_PATH: any = {
  'profile': '/img/default-images/profile.png',
  'partner': '/img/default-images/partner.png',
  'collection': '/img/default-images/collection-default.png',
  'assessment': '/img/default-images/assessment-default.png',
  'collection-external': '/img/default-images/collection-default.png',
  'assessment-external': '/img/default-images/assessment-default.png',
  'noImage': '/img/default-images/No-Image.png',
  'noVideo': '/img/default-images/No-Video.png',
  'marker': '/img/student-marker.png',
  'offlineActivity': `/img/default-images/offline-activity-default.png`,
  'unit': `/img/default-images/course-default.png`,
  'course': '/img/default-images/course-default.png',
  'loader': '/img/default-images/loader.svg',
  'offline-activity': `/img/default-images/offline-activity-default.png`,
  'dataLakeIcon': `/img/default-images/data-lake-super.png`,
  'dataLakeLearning': `/img/default-images/data-lake-learning.png`,
  'freeUser': '/img/default-images/blueIcon.svg',
  'paidUser': '/img/default-images/greenIcon.svg',
};

export const ROUTE_MAP_ICONS = {
  startPoint: '/img/map-icon.svg',
  destination: '/img/map-pointer.svg',
};

// Competency status
export const COMPETENCY_STATUS = [
  'Not Started',
  'In Progress',
  'Mastered (Inferred)',
  'Mastered (Asserted)',
  'Mastered (Earned)',
  'Mastered (Demonstrated)',
];

export const LEARNING_MAP_CONTENT_TYPE = [
  {
    labelKey: 'assessment',
    type: 'assessment',
  },
  {
    labelKey: 'collection',
    type: 'collection',
  },
  {
    labelKey: 'resource',
    type: 'resource',
  },
  {
    labelKey: 'offline activity',
    type: 'offline-activity',
  },
  {
    labelKey: 'course',
    type: 'course',
  },
  {
    labelKey: 'question',
    type: 'question',
  },
  {
    labelKey: 'lesson',
    type: 'lesson',
  },
  {
    labelKey: 'unit',
    type: 'unit',
  },
  {
    labelKey: 'rubric',
    type: 'rubric',
  },
];

export const PORTFOLIO_CONTENT_TYPES = [
  {
    name: 'Assessment(s)',
    key: 'assessment',
  },
  {
    name: 'Collection(s)',
    key: 'collection',
  },
  {
    name: 'Offline Activity(s)',
    key: 'offline-activity',
  },
];

export const GRADING_SCALE = [{
  LOWER_LIMIT: 0,
  COLOR: '#F46360',
  RANGE: '0-59',
},
{
  LOWER_LIMIT: 60,
  COLOR: '#ED8E36',
  RANGE: '60-69',
},
{
  LOWER_LIMIT: 70,
  COLOR: '#FABA36',
  RANGE: '70-79',
},
{
  LOWER_LIMIT: 80,
  COLOR: '#A8C99C',
  RANGE: '80-89',
},
{
  LOWER_LIMIT: 90,
  COLOR: '#4B9740',
  RANGE: '90-100',
},
];

export const LEARNER_PREFERENCE_META: any = {
  video: {
    labelKey: 'Video Resources',
    icon: 'video-resource',
  },
  webpage: {
    labelKey: 'Web Based Resources',
    icon: 'website-resource',
  },
  interactive: {
    labelKey: 'Interactive Resources',
    icon: 'interactive-resource',
  },
  image: {
    labelKey: 'Image Resources',
    icon: 'image-resource',
  },
  text: {
    labelKey: 'Text Resources',
    icon: 'text-resource',
  },
  audio: {
    labelKey: 'Audio Resources',
    icon: 'audio-resource',
  },
  project: {
    labelKey: 'Project',
    icon: 'offline-activity-gray',
  },
};

export const COMPETENCY_NAVIGATION_MENUS = [
  'competency-map',
  'tree',
  'crosswalk',
  'learning-map',
];

export const GOORU_DEFAULT_STANDARD = 'GDF';

export const GOORU_DEFAULT_FRAMEWORK = 'GDT';

export const MICRO_COMPETENCY_CODE_TYPES = [
  'learning_target_level_0',
  'learning_target_level_1',
  'learning_target_level_2',
];

export const TAXONOMY_LEVELS = {
  COURSE: 'course',
  DOMAIN: 'domain',
  STANDARD: 'standard',
  MICRO: 'micro-standard',
};

export const LEARNER_MINDSETS_VECTORS = [
  'grit',
  'perseverance',
  'motivation',
  'selfConfidence',
];

export const LEARNER_COMMUNITY_VECTORS = [
  'citizenship',
  'authority',
  'reputation',

];
export const DEMO_USERS = [
  'e062559a-35d2-45e9-85fd-380987dc2fdf',
  '9a7e544f-570a-487d-ad48-a0bba15d42e7',
];

export const PL_DEMO_USERS = [
  'e87862d5-9c65-456a-9d4e-d35a73fcf212',
];

export const PROFICIENCY_ROUTE_VIEW = [
  'c0ddb912-20bc-46be-a295-9edfb5cc6113',
];

export const PERMISSION_LIST = {
  networkView: 'network-view',
  competencyView: 'competency-view',
  learnersView: 'learners-view',
  consoleView: 'console-view',
  catalogView: 'catalog-view',
  networkMap: 'network-map',
  compDrilldown: 'competency-drilldown',
  compDrillAnalytic: 'competency-drilldown-analytic',
  compDashboard: 'competency-dashboard',
  partner: 'content-provider',
  learnerIdentity: 'learners-identity',
  learners: 'learners',
  console: 'console',
  learningRegistryView: 'learning-registry-view',
  dataLakeView: 'data-lake-view',
  reportsView: 'reports-view',
  all: 'all',
  roleView: 'role-view',
  guest: 'guest',
  hideCatalog: 'hide-catalog',
  showcase: 'showcase',
  showGPFCompReport: 'show-gpf-report',
  impact: 'impact',
  activeUsersTrendReportsView: 'active-users-trend-reports',
  nudgeEngagementReportsView: 'nudge-engagement-reports',
  nudgeTimeSpendReportsView: 'nudge-time-spend-reports',
  userSessionTimeReportsView: 'users-session-time-reports',
  nudgeFeedbackResportsView: 'nudge-feedback-reports',
};

export const ROLE_MENUS = {
  'network': 'network',
  'impact': 'impact',
  'competency': 'competency',
  'learners': 'learners',
  'catalog': 'catalog',
  'console': 'console',
  'research': 'research',
  'partners': 'partners',
  'learning-registry': 'learning-registry',
  'data-lake': 'data-lake',
  'collaborators': 'collaborators',
  'reports': 'reports',
  'nav': 'nav',
  'all': 'all',
  'guest': 'guest',
  'hide-catalog': 'hide-catalog',
  'showcase': 'showcase',
  'data-lake-report': 'data-lake-report',
  'mygooruInsights': 'mygooru-insights',
};

export const COUNTRY_HIERARCHY_ID = [
  {
    code: 'IN',
    hierarchyId: 1,
  },
  {
    code: 'US',
    hierarchyId: 2,
  },
];

export const COMPETENCY_REPORT_FREQUENCY = [
  {
    frequency: 'daily',
    label: 'Day',
  },
  {
    frequency: 'weekly',
    label: 'Week',
  },
  {
    frequency: 'monthly',
    label: 'Month',
  },
];

export const NETWORK_DRILLDOWN_LEVELS = [
  {
    group: 'country',
    drilldownLabel: 'common.state',
  },
  {
    group: 'state',
    drilldownLabel: 'common.school_district',
  },
  {
    group: 'school_district',
    drilldownLabel: 'common.school',
  },
  {
    group: 'school',
    drilldownLabel: 'common.class',
  },
  {
    group: 'class',
    drilldownLabel: 'common.student',
  },
];
export const FACETS_DEFAULT_FILTER: any = [
  'e8a409f5-7fd9-4027-8955-3eda9322413f',
];

export const SCHOOLS_SIGN_UP = 'https://goorulearning.com/get-started/schools-sign-up/';

export const GUEST_USER_DRILL_DOWN_IDS: any = {
  state: 2144,
  school_district: 3036,
  school: 20327,
  class: '2a67f142-bc80-4613-b5d4-27b94b7ea80d',
};

export const SOURCE_KEYS_AND_VALUES: any = {
  'lpbaseline-to-lpcs-migration': '',
  'initialSkylineGenerated': 'Student has demonstrated mastery in the competency after taking a diagnostic',
  'diagnostic': 'Student has demonstrated mastery in the competency after taking a diagnostic',
  'topic-based-lpcs-migration': '',
  'topic-based-lpcs-migration-lusd': '',
  'NWEA': `Student's mastery in the competency has been determined based on a standardized test scores (NWEA MAP)`,
  'NWEA-Asserted': `Student's mastery in the competency has been determined based on a standardized test scores (NWEA MAP)`,
  'ForceCalculateTrigger': `Student's mastery in the competency has been determined based on assertion`,
  'coursemap': '',
  'ILActivity': '',
  'dailyclassactivity': '',
  'Teacher-Asserted': '',
  'competencyMastery': '',
  'OfflineClassTrigger': '',
};

export const VECTOR_VALUES = [
  {
    label: 'grit',
    value: 0.5,
  },
  {
    label: 'perseverance',
    value: 0.4,
  },
  {
    label: 'motivation',
    value: 0.8,
  },
  {
    label: 'selfConfidence',
    value: 0.6,
  },
  {
    label: 'citizenship',
    value: 0.5,
  },
  {
    label: 'authority',
    value: 0.8,
  },
  {
    label: 'reputation',
    value: 0.4,
  },
];

export const COMPLIANCE_DATA = [
  {
    label: 'Information Security',
    value: 0.8,
  },
  {
    label: 'Regulatory Compliance',
    value: 0.4,
  },
  {
    label: 'Data Protection & Privacy',
    value: 0.6,
  },
  {
    label: 'Workplace Anti-harassment',
    value: 0.2,
  },
  {
    label: 'Diversity',
    value: 0.7,
  },
];

export const TEMP_CONST_LEARNER = ['e8a409f5-7fd9-4027-8955-3eda9322413f'];

export const CLASS_SORT_TYPES = [
  {
    name: 'By Teacher',
    key: 'last_name',
  },
  {
    name: 'By Class',
    key: 'name',
  },
  {
    name: 'By Competency count',
    key: 'masteredCompetencies',
  },
];


export const DEMO_HIERARCHY_LIST: any = {
  country: ['US', 'UK', 'Germany', 'Dubai', 'India', 'Philippines', 'Hong Kong', 'Australia'],
  state: ['Data Analytics', 'Strategic Consulting', 'Risk Management', 'Banking & Finance', 'Healthcare', 'Manufacturing', 'Insurance'],
  school_district: ['Demand Management', 'Analytics Development', 'Data Governance', 'Analytics Support', 'Analytics Platform', 'Training'],
};

export const DEMO_HIERARCHY_HEADS: any = {
  country: 'Countries',
  state: 'Divisions',
  school_district: 'Departments',
  school: 'Sections',
  class: 'Learners',
  student: 'Learners',
};
export const DEMO_HIERARCHY_POPUP_HEADS: any = {
  country: 'World',
  state: 'Countries',
  school_district: 'Divisions',
  school: 'Departments',
  class: 'Sections',
  student: 'Class',
};


export const COMPETENCY_STUBS_LIST: any = {
  description: 'Software Engineer',
  grade: 'Software Engineer',
  gradeId: 320,
  gradeSeq: 1,

  competencies: [{
    compCode: 'STS.PL.STS-SE-SQL-5',
    compName: 'Understanding data types & temporal tables',
    compDisplayCode: 'SE.SQL.5',
    compSeq: 1,
  }, {
    compDisplayCode: 'SE.PYTH.2',
    compCode: 'STS.PL.STS-SE-PYTH-2',
    compSeq: 2,
    compName: 'Understand Python variables, data types & operators',
  }, {
    compDisplayCode: 'SE.PYTH.5',
    compCode: 'STS.PL.STS-SE-PYTH-5',
    compSeq: 3,
    compName: 'Understand Generic functions: Len, Range, Iter, User-defined, Lambda',
  },
  {
    compDisplayCode: 'SE.TABL.7',
    compCode: 'STS.PL.STS-SE-TABL-7',
    compSeq: 4,
    compName: 'Difference between continuous and discrete date fields',
  },
  {
    compDisplayCode: 'EM.ISPO.1',
    compCode: 'STS.PL.STS-EM-ISPO-1',
    compSeq: 5,
    compName: 'Ability to understand and follow applicable Privacy Policies',
  }],
};


export const STUDENT_TIMESPENT_DATA: any = {
  country: {
    students: 2468,
    index: 0.48,
    activeStudent: 1256,
  },
  state: {
    students: 1232,
    index: 0.54,
    activeStudent: 586,
  },
  school_district: {
    students: 124,
    index: 0.78,
    activeStudent: 85,
  },
  school: {
    students: 32,
    index: 0.72,
    activeStudent: 24,
  },
};

export const DEFAULT_CLASS_DRILLDOWN_STATE = {
  'fde60131-6812-4027-ba99-f430f391a31a': {
    competency: 106,
    inprogress: 5,
    performance: 88,
    timespent: 1015191,
  },
  '2a67f142-bc80-4613-b5d4-27b94b7ea80d': {
    competency: 28,
    inprogress: 6,
    performance: 75,
    timespent: 1215191.665,
  },
  'b1dc10eb-d31c-4829-884a-b7235d7021e1': {
    competency: 81,
    inprogress: 7,
    performance: 72,
    timespent: 915191.665,
  },
  '60bfb212-9ece-4993-9984-0708a01142f3': {
    competency: 56,
    inprogress: 10,
    performance: 60,
    timespent: 1015191.665,
  },
  '891b6327-fb6c-43a4-b97c-7212ff268105': {
    competency: 59,
    inprogress: 8,
    performance: 69,
    timespent: 305191.665,
  },
  '9adb0321-5b9b-4876-9a01-661ec3097adf': {
    competency: 77,
    inprogress: 4,
    performance: 75,
    timespent: 15191.665,
  },
  '53ac3a0c-ff9e-4935-b56d-fd98bfc6e974': {
    competency: 126,
    inprogress: 3,
    performance: 92,
    timespent: 2915191.665,
  },
};


export const DIAGNOSTIC_STATUS = {
  0: 'Not Started',
  1: 'Not Required',
  2: 'In Progress',
  3: 'Completed',
  4: 'Not Required',
  5: '--',
};

export const COLLABORATOR_TYPES: any = {
  content_provider: 'Content Provider',
  funders: 'Funders',
  integration_partners: 'Integration Partners',
  researchers: 'Researchers',
  content_developers: 'Content Developers',
  schools: 'Schools',
  lab_schools: 'Lab Schools',
};

export const MARKER_TYPES: any = {
  txImplicitMarker: 'Implicit Marker',
  txExplicitMarker: 'Explicit Marker',
};

export const CENTURY_SKILLS_GROUPS = {
  KEY_COGNITIVE_SKILLS_AND_STRATEGIES: 'Key Cognitive Skills and Strategies',
  KEY_CONTENT_KNOWLEDGE: 'Key Content Knowledge',
  KEY_LEARNING_SKILLS_AND_TECHNIQUES: 'Key Learning Skills and Techniques',
};

export const EXTRACTED = ['title', 'description', 'format'];
export const CURATED = [
  'Published By',
  'Publish Status',
  'Modified by',
  'Created by',
  'Aggregator',
  'Date Modified',
  'License',
  'language',
  'educational use',
  'accessbility',
  'grade',
  'age-range',
  'Editorial Range',
  'Audience',
  'Time Required',
  'media Features',
  'Grade Level',
  'access hazard',
  'advertisement level',
  'Learning Objective',
  'Keywords',
  'framebreaker',
  'Visibility',
];
export const TAGEED = [
  'Instructional Model',
  '21st Century Skills',
  'subject',
  'course',
  'domain',
  'audience',
  'standard',
  'Depth of Knowledge',
  'Reading Level',
];
export const COMPUTED = [
  'Publisher',
  'relevance',
  'engagement',
  'efficacy',
  'summary',
  'transcript',
  'address',
  'created by',
  'created on',
  'modified on',
  'modified by',
];


export const DEFAULT_CATALOG_STRING: any = {
  resource: {
    audio_resource: { name: 'Audio', colorCode: '#377eae' },
    video_resource: { name: 'Videos', colorCode: '#429aa9' },
    interactive_resource: { name: 'Interactive', colorCode: '#59b3a1' },
    image_resource: { name: 'Images', colorCode: '#78c69c' },
    webpage_resource: { name: 'Webpages', colorCode: '#99d59a' },
    text_resource: { name: 'Text', colorCode: '#b8e297' },
  },
  question: {
    multiple_choice_question: { name: 'Multiple Choice', colorCode: '#377eae' },
    multiple_answer_question: { name: 'Multiple Answer', colorCode: '#429aa9' },
    true_false_question: { name: 'True Or False', colorCode: '#59b3a1' },
    fill_in_the_blank_question: { name: 'Fill In The Blank', colorCode: '#78c69c' },
    hot_spot_image_question: { name: 'Multiple Select - Image', colorCode: '#99d59a' },
    hot_spot_text_question: { name: 'Multiple Select - Text', colorCode: '#b8e297' },
    hot_text_highlight_question: { name: 'Highlight Text', colorCode: '#d4ed96' },
    hot_text_reorder_question: { name: 'Drag And Drop Order', colorCode: '#e9f69d' },
    open_ended_question: { name: 'Open Ended', colorCode: '#f6f9a7' },
  },
};

export const USER_TYPE = {
  superUser: 'SUPER_USER',
  contentProvider: 'CONTENT_PROVIDER',
  districtUser: 'DISTRICT_USER',
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];


export const INSIGHTS_FILTERS_TYPE = {
  UserType: 'userType',
  NudgeType: 'nudgeType',
};

export const GROUP_TYPES = [
  'block',
  'cluster',
  'country',
  'district',
  'school',
  'school_district',
  'state',
  'class',
];

export const COUNTRY = 'country';

export const ReportDefaultColor = '#888';

export enum ReportTypeEnum {
  ACTIVE_USERS = 'active-users',
  SESSION_TIME = 'session-time',
  NUDGE_FEEDBACK = 'nudge-feedback',
  NUDGE_INTERACTION = 'nudge-interaction',
  NUDGE_USAGE = 'nudge-usage',
}

export const DEFAULT_REPORT_IMAGES_PATH: any = [
  '/img/default-images/student1.svg',
  '/img/default-images/student2.svg',
  '/img/default-images/student3.svg',
  '/img/default-images/student4.svg',
  '/img/default-images/student5.svg',
  '/img/default-images/student6.svg',
];

export const FEEDBACK_IDS: any = {
  1: 'like',
  2: 'dislike',
};

export const FEEDBACK_TYPES: any = {
  like: '1',
  dislike: '2',
};

export const frequencyTypes: any = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
};
